import ContactHeader from "./ContactHeader";
import Footer from "./Footer";
import Navbar from "./Navbar";

const PublicLayout = ({ children }) => {
  return (
    <>
      <div className="fixed top-0 left-0 w-full z-50 bg-white shadow-md">
        <ContactHeader />
        <Navbar />
      </div>
      {/* Main Content */}
      <div className="flex-1 min-h-screen pt-[130px] mb-0.5">{children}</div>
      {/* Footer */}

      <Footer />
    </>
  );
};

export default PublicLayout;
